import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ClienteOutput } from 'src/app/@shared/models/cliente.model';
import { ListarRoteirosResponse } from 'src/app/@shared/models/manifesto-embarque-gerar.model';
import { ProdutoOutput } from 'src/app/@shared/models/produto.model';
import { TipoVeiculoOutput } from 'src/app/@shared/models/tipo-veiculos';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { FreteDedicadoService } from 'src/app/services/frete-dedicado/frete-dedicado.service';
import { ManifestoEmbarqueGerarService } from 'src/app/services/manifesto-embarque-gerar/manifesto-embarque-gerar.service';
import { ProdutoService } from 'src/app/services/produto/produto.service';
import { TipoVeiculoService } from 'src/app/services/tipo-veiculo/tipo-veiculo.service';

@Component({
  selector: 'app-modal-novo-frete-dedicado',
  templateUrl: './modal-novo-frete-dedicado.component.html',
  styleUrls: ['./modal-novo-frete-dedicado.component.scss']
})
export class ModalNovoFreteDedicadoComponent implements OnInit, AfterViewInit {
  isLoading: boolean = true;
  freteId;
  rotaId;

  filterForm: FormGroup = new FormGroup({
    roteiroSelecionado: new FormControl('', Validators.required),
    clienteSelecionado: new FormControl('', Validators.required),
    produtoSelecionado: new FormControl('', Validators.required),
    tipoVeiculo: new FormControl('', Validators.required),
    valorFrete: new FormControl('', Validators.required),
    gris: new FormControl('', Validators.required),
    adv: new FormControl('', Validators.required),
    valorPedagio: new FormControl('', Validators.required),
    ativo: new FormControl('', Validators.required)
  });
  get roteiroSelecionado() { return this.filterForm.get('roteiroSelecionado').value; }
  get clienteSelecionado() { return this.filterForm.get('clienteSelecionado').value; }
  get produtoSelecionado() { return this.filterForm.get('produtoSelecionado').value; }
  get tipoVeiculo() { return this.filterForm.get('tipoVeiculo').value; }
  get valorFrete() { return this.filterForm.get('valorFrete').value; }
  get gris() { return this.filterForm.get('gris').value; }
  get adv() { return this.filterForm.get('adv').value; }
  get valorPedagio() { return this.filterForm.get('valorPedagio').value }
  get ativo() { return this.filterForm.get('ativo').value; }

  private onDestroy = new Subject<void>();
  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<ClienteOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();

  produtos: ProdutoOutput[];
  public filteredProdutos: ReplaySubject<ProdutoOutput[]> = new ReplaySubject<ProdutoOutput[]>(1);
  public produtoMultiFilter: FormControl = new FormControl();

  veiculos: TipoVeiculoOutput[];
  public filteredVeiculos: ReplaySubject<TipoVeiculoOutput[]> = new ReplaySubject<TipoVeiculoOutput[]>(1);
  public veiculosMultiFilter: FormControl = new FormControl();

  roteiros;
  roteiroIdSelecionado: any;
  public filteredRoteiros: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public roteiroMultiFilter: FormControl = new FormControl();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private roteiroService: ManifestoEmbarqueGerarService,
    public snackBar: MatSnackBar,
    public clienteService: ClienteService,
    public produtoService: ProdutoService,
    public tipoVeiculoService: TipoVeiculoService,
    public freteService: FreteDedicadoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalNovoFreteDedicadoComponent>,
  ) {
    data && data.rotaId ? this.rotaId = data.rotaId : null;
    data ? this.freteId = data : this.freteId = null;
  }

  ngOnInit() { };

  ngAfterViewInit() {
    this.esperarCarregarDados();
  }

  async esperarCarregarDados() {
    if (this.rotaId) {
      this.filterForm.get('roteiroSelecionado').setValue(this.rotaId);
    } else if (this.freteId) {
      this.carregarDados();
      this.listarProdutos();
    }

    await Promise.all([
      this.listarClientes(),
      this.listarTiposVeiculos(),
      this.listarRoteiros(),
    ]);

    this.isLoading = false;
  }

  encodeURI(data: any): string {
    return btoa(JSON.stringify(data));
  }

  public async listarClientes() {
    return this.clienteService.list().toPromise().then((response: ClienteOutput[]) => {
      this.clientes = response.filter(x => x.nome != '').sort((a, b) => (a.nome < b.nome ? -1 : 1));
      this.filteredClientes.next(this.clientes.slice());
      this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.filteredClientes, 'nome');
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar clientes, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      });
  };

  public async listarProdutos() {
    this.produtos = [];
    return this.produtoService.selecionarProdutos(this.clienteSelecionado).toPromise().then((response: ProdutoOutput[]) => {
      this.produtos = response.filter(x => x.descricao != '').sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredProdutos.next(this.produtos.slice());
      this.produtoMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.produtos, this.produtoMultiFilter, this.filteredProdutos, 'descricao');
        });

      if (!this.produtos.length) {
        this.openSnackBar('Este cliente não possui produtos cadastrados!', 'OK', 5000, 'warning-snackbar');
        this.filterForm.get('produtoSelecionado').disable();
      }
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar produtos, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      });
  };

  public async listarTiposVeiculos() {
    return this.tipoVeiculoService.selecionarTipoVeiculo().toPromise().then((response: TipoVeiculoOutput[]) => {
      this.veiculos = response.filter(x => x.descTipoVeiculo != '').sort((a, b) => (a.descTipoVeiculo < b.descTipoVeiculo ? -1 : 1));
      this.filteredVeiculos.next(this.veiculos.slice());
      this.veiculosMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.veiculos, this.veiculosMultiFilter, this.filteredVeiculos, 'descTipoVeiculo');
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar produtos, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      });
  };

  public async listarRoteiros() {
    return this.roteiroService.listarRoteiros().toPromise().then((response: ListarRoteirosResponse[]) => {
      this.roteiros = response.filter(x => x.descricao != '').sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredRoteiros.next(this.roteiros.slice());
      this.roteiroMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.roteiros, this.roteiroMultiFilter, this.filteredRoteiros, 'descricao');
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar produtos, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      });
  };

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  };

  public carregarDados() {
    this.filterForm.get('roteiroSelecionado').setValue(this.freteId.roteiroID);
    this.filterForm.get('clienteSelecionado').setValue(this.freteId.clienteID);
    this.filterForm.get('produtoSelecionado').setValue(this.freteId.produtoID);
    this.filterForm.get('tipoVeiculo').setValue(this.freteId.tipoVeiculoID);
    this.filterForm.get('valorFrete').setValue(this.freteId.valorFrete);
    this.filterForm.get('gris').setValue(this.freteId.gris);
    this.filterForm.get('adv').setValue(this.freteId.adv);
    this.filterForm.get('valorPedagio').setValue(this.freteId.valorPedagio);
    this.filterForm.get('ativo').setValue(this.freteId.ativo);
  };

  salvarFrete() {
    if (this.freteId) {
      this.atualizarFrete();
    } else {
      this.novoFrete();
    }
  }

  public novoFrete() {
    const grisString = typeof this.gris === 'string' ? this.gris : this.gris.toString();
    const advString = typeof this.adv === 'string' ? this.adv : this.adv.toString();
    this.isLoading = true;
    const obj = {
      roteiroID: this.roteiroSelecionado,
      produtoID: this.produtoSelecionado,
      tipoVeiculoID: this.tipoVeiculo,
      valorFrete: this.valorFrete,
      gris: parseFloat(this.gris),
      adv: parseFloat(this.adv),
      valorPedagio: this.valorPedagio,
      ativo: this.ativo
    }

    this.freteService.incluirFreteDedicado(obj)
      .subscribe((response: any) => {
        if (response.isValid) {
          this.dialogRef.close('sucesso');
        } else {
          this.openSnackBar(response.notificacoes[0], 'OK', 10000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err)
        this.openSnackBar('Erro ao incluir novo Frete, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      })
      .add(() => this.isLoading = false);
  };

  public atualizarFrete() {
    const grisString = typeof this.gris === 'string' ? this.gris : this.gris.toString();
    const advString = typeof this.adv === 'string' ? this.adv : this.adv.toString();
    this.isLoading = true;
    const obj = {
      id: this.freteId.id,
      roteiroID: this.roteiroSelecionado,
      produtoID: this.produtoSelecionado,
      tipoVeiculoID: this.tipoVeiculo,
      valorFrete: this.valorFrete,
      gris: parseFloat(this.gris),
      adv: parseFloat(this.adv),
      valorPedagio: this.valorPedagio,
      ativo: this.ativo
    }

    this.freteService.atualizarFreteDedicado(obj)
      .subscribe((response: any) => {
        if (response.isValid) {
          this.dialogRef.close('sucesso');
        } else {
          this.openSnackBar(response.notificacoes[0], 'OK', 5000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err)
        this.openSnackBar('Erro ao atualizar Frete, entre em contato com o suporte : ' + (err.error.Protocolo ?? err.error.Message), 'OK', 10000, 'danger-snackbar');
      })
      .add(() => this.isLoading = false);
  };

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
